import {
  chakra,
  Box,
  Text,
  VStack,
  Image,
  Button,
  useDisclosure,
  Grid,
  Center,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  useMediaQuery,
  Progress,
  Textarea,
  HStack,
  Icon,
} from '@chakra-ui/react';
import { AccountContext } from 'components/AccountContext';
import BottomNavBar from 'components/BottomNavBar';
import React, { useCallback, useContext, useRef, useState } from 'react';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { api } from 'api/api';
// import BackButton from '../../../../../images/assets/telemedicina/backbutton.svg';
import especialistas from '../../../../../images/doctor-badge.svg';
import telemedDeslogado from '../../../../../images/Deslogado/telemedDeslogado.svg';
import { ReactComponent as InfoCircle } from '../../../../../images/info-circle.svg';
import ChildHeader from '../../ChildHeader';
import useModelButtonTelemedicina from 'components/Dashboard/ButtonTelemedicina/useModelButtonTelemedicina';
import SelectField from 'components/SelectField';
import { Formik } from 'formik';
import TextField from 'components/TextField';
import { WarningTwoIcon } from '@chakra-ui/icons';

const ENDPOINT =
  process.env.REACT_APP_ENVIRONMENT === 'production'
    ? process.env.REACT_APP_BASE_URL_API_SERVER_PROD
    : process.env.REACT_APP_BASE_URL_API_SERVER_TEST;

const onlyNumbers = (str) => str.replace(/[^0-9]/g, '');

async function saveError(username, error) {
  const postsData = await api(`${ENDPOINT}/clients/telemedicioneError`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ username, error }),
  });
  const response = await postsData.json();
  console.log('response ', response);
}

function DesistenciaModal({ state, agenda, setPausedFetchRdy }) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { isOpen: isOpenPosDesistencia, onOpen: openPosDesistencia, onClose: closePosDesistencia } = useDisclosure();
  const [checkingFaturado, setCheckingFaturado] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState();
  const navigate = useNavigate();
  const [tipoDesistencia, setTipoDesistencia] = useState('credito');
  const [isFaturado, setIsFaturado] = useState();
  const { user, setUser, updateData, loadedMedicina } = useContext(AccountContext);
  const [motivosDesistencia, setMotivosDesistencia] = useState([]);
  const [motivoEscolhido, setMotivoEscolhido] = useState(null);
  const [outroTexto, setOutroTexto] = useState('');
  const [disabledCancelamento, setDisabledCancelamento] = useState(true);
  const [cancelamento_id, setCancelamentoId] = useState(null);
  async function fetchMotivosDesistencia() {
    try {
      const postsData = await api(`${ENDPOINT}/clients/fetchMotivosDesistencia`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({}),
      });
      const response = await postsData.json();
      if (response !== null || response !== undefined) {
        setMotivosDesistencia(response);
      }
    } catch (error) {
      console.log(error);
      setError('Houve um problema ao buscar pelos motivos de desistência');
    }
  }

  const SelectClient = () => {
    const optionsData = motivosDesistencia.map((m) => ({
      id: m.cancelamento_id,
      descricao: m.descricao,
    }));

    const arrayMotivosDesistencia = optionsData.map((m) => m.descricao);

    return (
      <SelectField
        name="motivos"
        background="#F3F3F3"
        color="#585858"
        placeholder="Selecione o motivo"
        variant="outline"
        textAlign="left"
        borderColor="gray.300"
        w="100%"
        borderRadius="10px"
        fontWeight="bold"
        options={arrayMotivosDesistencia}
        fontSize="sm"
        onChange={(index) => {
          if (index >= 0) {
            const motivoSelecionado = optionsData[index];
            setMotivoEscolhido(motivoSelecionado);
            setCancelamentoId(motivoSelecionado.id);
          }
        }}
      />
    );
  };

  const desistirAtendimento = useCallback(async () => {
    setPausedFetchRdy(true);
    setIsLoading(true);
    setError(null);
    try {
      const response = await api(
        ENDPOINT +
          `/schedule/updateTelemedAtendimento/${agenda}/${onlyNumbers(state.patient)}/${cancelamento_id}/$${
            outroTexto ? encodeURIComponent(outroTexto) : null
          }/${user?.credito_id}`,
        {
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
          },
          method: 'GET',
        }
      );
      const postsData = await response.json();
      navigate('/dashboard', { replace: true });
    } catch (error) {
      console.log(error);
      setError('Error ao tentar desistir da fila ', error);
    } finally {
      setPausedFetchRdy(false);
      setIsLoading(false);
    }
  }, [agenda, navigate, setPausedFetchRdy, state.patient, cancelamento_id, outroTexto]);

  const desistirAtendimentoCredito = useCallback(async () => {
    setPausedFetchRdy(true);
    setIsLoading(true);
    setError(null);
    try {
      const response = await api(
        ENDPOINT +
          `/schedule/updateTelemedAtendimento/${agenda}/${onlyNumbers(state.patient)}/${cancelamento_id}/$${
            outroTexto ? encodeURIComponent(outroTexto) : null
          }/${user?.credito_id}`,
        {
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
          },
          method: 'GET',
        }
      );
      const postsData = await response.json();

      setTipoDesistencia('credito');
      onClose();
      openPosDesistencia();
    } catch (error) {
      console.log(error);
      setError('Error ao setar o tipo de desistencia da fila ', error);
    } finally {
      setIsLoading(false);
    }
  }, [agenda, onClose, openPosDesistencia, setPausedFetchRdy, state.patient, cancelamento_id, outroTexto]);

  const desistirAtendimentoReembolso = useCallback(async () => {
    setPausedFetchRdy(true);
    setIsLoading(true);
    setError(null);
    try {
      const response = await api(
        ENDPOINT +
          `/schedule/updateTelemedAtendimento/${agenda}/${onlyNumbers(state.patient)}/${cancelamento_id}/$${
            outroTexto ? encodeURIComponent(outroTexto) : null
          }/${user?.credito_id}?reembolso=true`,
        {
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
          },
          method: 'GET',
        }
      );
      const postsData = await response.json();

      setTipoDesistencia('reembolso');
      onClose();
      openPosDesistencia();
    } catch (error) {
      console.log(error);
      setError('Error ao desistir da fila ', error);
    } finally {
      setIsLoading(false);
    }
  }, [agenda, onClose, openPosDesistencia, setPausedFetchRdy, state.patient, cancelamento_id, outroTexto]);

  const verificarFaturado = useCallback(async () => {
    setPausedFetchRdy(true);
    setCheckingFaturado(true);
    setError(null);
    try {
      const response = await api(ENDPOINT + `/schedule/verifica-faturado/${agenda}`, {
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
      });
      const data = await response.json();
      setIsFaturado(data.faturado);
    } catch (error) {
      console.log(error);
      setError('Error ao verificar valor faturado ', error);
    } finally {
      setPausedFetchRdy(false);
      setCheckingFaturado(false);
    }
  }, [agenda, setPausedFetchRdy]);

  let usuarioAssinante = user.id_contrato && user.descricao_plano ? true : false;
  if (user.titular === false) usuarioAssinante = true;

  useEffect(() => {
    fetchMotivosDesistencia();
  }, []);

  useEffect(() => {
    if (motivoEscolhido == null) {
      setDisabledCancelamento(true);
      return;
    }

    if (motivoEscolhido?.descricao !== 'Outro') {
      setOutroTexto(null);
    }

    if (motivoEscolhido?.descricao == 'Outro' && outroTexto === '') {
      setDisabledCancelamento(true);
      return;
    }

    setMotivoEscolhido(motivoEscolhido);
    setDisabledCancelamento(false);
    setOutroTexto(outroTexto);
  }, [motivoEscolhido, outroTexto]);

  return (
    <>
      <Button
        isFullWidth
        size="sm"
        colorScheme="gray"
        variant="outline"
        color="#585858"
        mt={4}
        isLoading={checkingFaturado}
        onClick={async () => {
          //await verificarFaturado();
          onOpen();
        }}
      >
        Desistir do atendimento
      </Button>
      <Modal isOpen={isOpen} onClose={onClose} size="lg" isCentered>
        <ModalOverlay />
        <ModalContent textAlign={'center'} borderRadius={20} m={8}>
          <ModalHeader fontSize={'md'} mt={2}>
            Você tem certeza disso?
          </ModalHeader>
          <ModalBody>
            <Text fontSize={'md'} color={'#585858'}>Se desistir do atendimento, você perderá sua posição na fila.</Text>
          </ModalBody>
          <ModalFooter>
            <Formik initialValues={{ clients: 0 }} validateOnChange={false} validateOnBlur={false}>
              <VStack w={'100%'}>
                {error && (
                  <Text fontSize={'md'} fontWeight={'bold'} bgColor={'#CB0000'} color={'white'} p={2} rounded={10}>
                    Falha na conexão
                  </Text>
                )}

                {!user.pronto_gratis && (
                  <Box
                    borderRadius="0.8em"
                    p={4}
                    w="100%"
                    border="1px solid #FFCBCF"
                    bg="linear-gradient(90deg, #FFEAED 0%, #FFEAED 100%)"
                    boxShadow="0 0 5px rgba(255, 203, 207, 0.5)"
                  >
                    <VStack align="flex-start" spacing={1}>
                      <HStack spacing={2}>
                        <WarningTwoIcon color="#D62422" boxSize={4} />
                        <Text fontWeight="bold" fontSize="0.9em" color="#D62422">
                          Importante!
                        </Text>
                      </HStack>

                      <Text textAlign={'left'} color="#D62422" fontSize="0.8em">
                        A consulta <b>não poderá ser reagendada</b>. Para marcar outra, <b>será necessário um novo pagamento</b>.
                      </Text>
                    </VStack>
                  </Box>
                )}
                <Text color={'#585858'} fontSize={'md'} textAlign={'center'} w={'100%'}>
                  Nos informe o motivo da sua desistência
                </Text>
                <SelectClient />

                {motivoEscolhido?.descricao == 'Outro' && (
                  <Textarea
                    placeholder="Digite seu motivo aqui..."
                    value={outroTexto}
                    onChange={(e) => setOutroTexto(e.target.value)}
                    resize="none"
                    borderRadius="lg"
                    borderColor="gray.300"
                    _hover={{ borderColor: 'gray.400' }}
                    _focus={{
                      borderColor: 'blue.400',
                      boxShadow: '0 0 0 1px #4299E1',
                    }}
                    fontSize="md"
                    p={3}
                  />
                )}

                <Button
                  size="sm"
                  colorScheme="teal"
                  onClick={() => {
                    if (motivoEscolhido.descricao === 'Outro' && outroTexto === '') {
                      return;
                    }
                    desistirAtendimento();
                  }}
                  isFullWidth
                  isLoading={isLoading}
                  isDisabled={disabledCancelamento}
                >
                  Confirmar desistência
                </Button>

                <Button size="sm" disabled={isLoading} colorScheme="gray" onClick={onClose} variant="ghost" isFullWidth>
                  Cancelar
                </Button>
              </VStack>
            </Formik>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Modal isOpen={isOpenPosDesistencia} onClose={closePosDesistencia} size="xs" isCentered>
        <ModalOverlay />
        <ModalContent textAlign={'center'} borderRadius={20} m={8}>
          <ModalHeader fontSize={'md'}>Recebemos sua solicitação</ModalHeader>
          <ModalBody fontSize={'sm'}>
            {tipoDesistencia === 'credito' && 'O crédito ficará disponível para a sua próxima consulta'}
            {tipoDesistencia === 'reembolso' &&
              'Para solicitar o reembolso, por favor, entre em contato com nossa central de atendimento pelo número 0800 280-2133 (Whatsapp)'}
          </ModalBody>

          <ModalFooter>
            <VStack w={'100%'}>
              {error && (
                <Text fontSize={'sm'} fontWeight={'bold'} bgColor={'#CB0000'} color={'white'} p={2} rounded={10}>
                  {error}
                </Text>
              )}

              <Button
                size="sm"
                colorScheme="teal"
                onClick={() => {
                  navigate('/dashboard', { replace: true });
                }}
                isFullWidth
                isLoading={isLoading}
              >
                Entendi
              </Button>
            </VStack>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}

function AtendimentoTelmedicina() {
  const [md] = useMediaQuery('(min-width: 375px)');
  const { setPage } = useContext(AccountContext);
  setPage('Telemedicina');
  const { state } = useLocation();
  const { user } = useContext(AccountContext);
  const [reconnect, setReconnect] = useState(false);
  const [error, setError] = useState(false);
  const [isLoading, setLoading] = useState(true);
  const [success, setSuccess] = useState(false);
  const [medico, setMedico] = useState('');
  const [faturado, setFaturado] = useState(state.faturado);
  const [paciente, setPaciente] = useState('');
  const [agenda, setAgenda] = useState('');
  const [queued, setQueued] = useState(false);
  const [position, setPosition] = useState(false);
  const [tempo, setTempo] = useState(false);
  const [pausedFetchRdy, setPausedFetchRdy] = useState(false);
  const intervalRef = useRef();
  const navigate = useNavigate();
  const today = new Date().toISOString().substring(0, 10);
  const url = ENDPOINT + '/schedule/appointment_telemed';

  const payload = {
    cpf: onlyNumbers(state.patient),

    cart: {
      convenio_id: 252,
      dia_previsao: 0,
      grupo: 'CONSULTA TELEMEDICINA',
      materiais: '',
      nome: 'CONSULTA TELEMEDICINA',
      procedimento_convenio_id: 6178,
      procedimento_tuss_id: 173059,
      valor: '0,00',
      faturado: state?.faturado,
    },
    turno: 'manhã',
    valor: 0,
    empresa: {
      ativo: true,
      bairro: 'Centro',
      cep: '63500-065',
      descricao:
        'Iniciamos nossas atividades em 2006, tendo como base fundamental a garantia de um bom atendimento e qualidade. Com união entre profissionais qualificados e tecnologia avançada, conquistamos a confiança de nossos clientes, trazendo resultados com agilidade e precisão.     Além da sede em Iguatu/CE, hoje estamos presentes em Fortaleza, região metropolitana, e em diversas cidades do estado do Ceará.',
      empresa: 'ADOLFO LUTZ',
      empresa_id: 1,
      endereco: 'Rua Deputado Adail Barreto',
      estado: 'CEARA',
      grupo: 'ENDOSCOPIA',
      horario_sab_fim: '13:00',
      horario_sab_inicio: '06:00',
      horario_seg_sex_fim: '18:00',
      horario_seg_sex_inicio: '06:00',
      municipio: 'IGUATU',
      numero: '54',
      ordem: '1',
      telefone_01: '0800 280 2133',
      telefone_02: '88 981189898',
    },
    triagem: state?.triagem,
    data: today,
    credito: state?.credito,
    metadataCoparticipacao: state?.metadataCoparticipacao,
    credito_id: user?.credito_id,
  };

  const fetchPosts = async () => {
    try {
      console.log('Enviando para fila de telemedicina o payload: ', payload);
      if (queued === false) {
        setQueued(true);

        const response = await api(url, {
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
          },
          method: 'POST',
          body: JSON.stringify(payload),
        });
        const postsData = await response.json();
        setSuccess(postsData.success);
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    if (success === false && state?.status !== 'telemed_paga') {
      fetchPosts();
    } else if (state?.status === 'telemed_paga') {
      setSuccess(true);
    }
  }, [success, state?.status]);

  async function validaFilaAtendimento(agendaId) {
    return await api(`${ENDPOINT}/cache/telemedicine`, {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then(async (res) => {
        return res.json();
      })
      .then(async (resposta) => {
        if (resposta.length > 0) {
          return resposta.filter((filtrado) => filtrado.agenda_exames_id == agendaId)[0];
        }
        return null;
      });
  }

  async function updateCredito(agenda_exames_id) {
    setLoading(true);
    try {
      console.log({ credito_id: user.credito_id, agenda_exames_id: agenda_exames_id });
      const response = await api(ENDPOINT + `/pacientes/updateCreditoPaciente/`, {
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body: JSON.stringify({ credito_id: user.credito_id, agenda_exames_id: agenda_exames_id }),
      });
      const postsData = await response.json();
      console.log('update credito response ', postsData);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  }

  const fetchRdy = async () => {
    try {
      const response = await api(ENDPOINT + `/schedule/scheduletelemed/${state.patient}`, {
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
      });
      const postsData = await response.json();
      console.log(postsData);
      setPosition(postsData.position);
      setTempo(postsData.avg_wait_time);
      setAgenda(postsData.agenda_exames_id);
      setFaturado(postsData.faturado);
      setError(false);
      setReconnect(false);
      console.log(position);
      if (postsData.medico_ready === true) {
        setMedico(postsData.medico_id);
        setAgenda(postsData.agenda_exames_id);
        setPaciente(postsData.paciente_id);
        const agendamento = await validaFilaAtendimento(postsData.agenda_exames_id);
        if (agendamento?.telemedicina_versao == 2) {
          const nomePartes = user?.name.split(' ');
          const primeiroNome = nomePartes[0];
          const sobrenome = nomePartes.length > 1 ? nomePartes[1] : '';
          navigate('/video-chamada', {
            state: {
              channelName: `telemedicina_${postsData.agenda_exames_id}`,
              userId: `${primeiroNome} ${sobrenome}`,
              jwt: '123',
              agenda_exames_id: postsData.agenda_exames_id,
            },
          });
          return;
          navigate('/pre-video-chamada', {
            state: {
              atendimentoId: postsData.agenda_exames_id,
            },
          });
          return;
        }
        window?.ReactNativeWebView?.postMessage(
          JSON.stringify({
            service: true,
            openInBrowser: false,
            url: `https://atendimento.deovita.com.br:5000/atendimento?p=${postsData.paciente_id}&m=${postsData.medico_id}&a=${postsData.agenda_exames_id}&u=paciente`,
          })
        );
        navigate('/dashboard');
        /* 
          navigate('/video-chamada', {
            channelName: 'minha-sala-de-video',
            userId: 'usuario123',
            jwt: '123',
          });
        */
        /* const isAndroid = user.device === 'android' ? true : false;

        if(isAndroid) {
          window.location = `https://atendimento.deovita.com.br:5000/atendimento?p=${postsData.paciente_id}&m=${postsData.medico_id}&a=${postsData.agenda_exames_id}&u=paciente`
        }




        else {
          setLoading(false)
          /* window?.ReactNativeWebView?.postMessage(
            JSON.stringify({
              service: true,
              url: `https://atendimento.deovita.com.br:5000/atendimento?p=${postsData.paciente_id}&m=${postsData.medico_id}&a=${postsData.agenda_exames_id}&u=paciente`
            })
          );



        }

*/

        //setLoading(false);
        const highestId = window.setTimeout(() => {
          for (let i = highestId; i >= 0; i--) {
            window.clearInterval(i);
          }
        }, 0);
      }
    } catch (error) {
      setError('Error no fetch de mandar para a fila ', error);
      console.log(error);
    }
  };

  useEffect(() => {
    if (success === true && !pausedFetchRdy) {
      intervalRef.current = setInterval(fetchRdy, 10000);
    }

    return () => clearInterval(intervalRef.current);
  }, [success, pausedFetchRdy]);

  useEffect(() => {
    const save = async () => {
      if (error) {
        try {
          await saveError(user.username, error);
        } catch (err) {
          console.error('Erro ao salvar o log de erro:', err);
        }
      }
    };

    save();
  }, [error]);

  let usuarioAssinante = user.id_contrato && user.descricao_plano ? true : false;
  if (user.titular === false) usuarioAssinante = true;
  return isLoading ? (
    <>
      {/* <Image top="2.5em" left="1.3em" zIndex="9999" position="absolute" src={BackButton} onClick={() => navigate(-1)} /> */}
      <Center flexDirection={'column'} minH="100vh" background={usuarioAssinante ? '#5AB2AE' : '#5AB2AE'} p={md ? 8 : 4} pb={20}>
        <Box borderRadius={20} backgroundColor="white" textAlign="center" p={md ? 8 : 4} fontSize="xs">
          <Box display={'flex'} flexDirection={'column'} alignItems={'center'}>
            <Image src={!usuarioAssinante ? telemedDeslogado : especialistas} h={md ? '5em' : '3em'} w={md ? '5em' : '3em'} />
            {faturado || (!user.allowsTelemedicina?.paga_telemedicina && usuarioAssinante) ? (
              <>
                <Text color="#585858" fontWeight="bold" fontSize={md ? 'lg' : 'sm'} mt={4}>
                  Agora é só aguardar!
                </Text>
                <Text>
                  {error !== false && error !== undefined ? (
                    'Falha na conexão'
                  ) : position !== null ? (
                    position === false || position === undefined ? (
                      'conectando...'
                    ) : (
                      <Box pt={4}>
                        <Text>Você é o </Text>
                        <Text fontSize={'md'} fontWeight="bold" color={usuarioAssinante ? '#5AB2AE' : '#5AB2AE'}>{`${position}º da fila`}</Text>
                      </Box>
                    )
                  ) : (
                    'iniciando atendimento...'
                  )}
                </Text>

                <Text mt={4}>
                  {tempo && (tempo === false || tempo === undefined) ? (
                    ''
                  ) : tempo > 0 ? (
                    <Box borderTop={'2px solid #DFDFDF'} pt={4}>
                      <Text>Tempo estimado de espera</Text>
                      <Text fontSize={'md'} fontWeight="bold" color={usuarioAssinante ? '#5AB2AE' : '#5AB2AE'}>
                        {Math.round(tempo / 60) > 0 ? `${Math.round(tempo / 60)} minutos` : 'menos de 1 minuto'}
                      </Text>
                    </Box>
                  ) : (
                    ''
                  )}
                </Text>
              </>
            ) : (
              <>
                <Text color={usuarioAssinante ? '#5AB2AE' : '#5AB2AE'} fontWeight="bold" fontSize={md ? 'lg' : 'sm'} mt={4}>
                  Aguardando confirmação de pagamento
                </Text>
                <Progress colorScheme="orange" isIndeterminate size="xs" width={'75%'} rounded={'lg'} my={4} />
              </>
            )}

            {/* <Accordion allowToggle mt={4} w={'100%'} bgColor={'#DFDFDF'} color={'#585858'} borderRadius={10}>
              <AccordionItem>
                <AccordionButton display={'flex'} justifyContent={'space-between'} p={4}>
                  <InfoCircle />
                  <AccordionIcon />
                </AccordionButton>

                <AccordionPanel px={4} textAlign={'left'}>
                  É importante lembrar que o profissional de saúde pode demorar um pouco mais durante o atendimento. Ou seja, seu lugar na fila e o
                  tempo estimado pode aumentar ou diminuir.
                </AccordionPanel>
              </AccordionItem>
            </Accordion> */}

            <Box bgColor={'#DFDFDF'} color={'#585858'} p={4} textAlign={'left'} borderRadius={10} mt={md ? 10 : 4}>
              <InfoCircle style={{ height: '1rem' }} />
              <Text mt={4}>
                É importante lembrar que o profissional de saúde pode demorar um pouco mais durante o atendimento. Ou seja, seu lugar na fila e o
                tempo estimado pode aumentar ou diminuir.
              </Text>
            </Box>

            <Text
              mt={5}
              color="#616161"
              fontSize={'1.4em'}
              fontWeight="semibold"
              onClick={() => {
                setReconnect(true);
                fetchRdy();
              }}
            >
              {reconnect ? 'Reconectando..' : ` Problemas na conexão? \n Clique aqui para reconectar`}
            </Text>

            {faturado && position !== false && position?.length > 0 && (
              <DesistenciaModal state={state} agenda={agenda} setPausedFetchRdy={setPausedFetchRdy}></DesistenciaModal>
            )}

            {/* <Text mt="1em" color="#585858" fontSize="sm" mb="0.5em">
                Para assegurar a sua posição na fila permaneça nessa tela, evite minimizar o aplicativo, nossa equipe de médico irá te atender em
                poucos instantes. Em caso de falha na sua conexão, não se preocupe, entraremos em contato para reestabelecer. Após o atendimento,
                aparecerá uma tela de feedback
              </Text> */}

            {/* <Box w="25em" h="3em" top={error !== false && error !== undefined ? '23em' : '25em'} borderRadius="10">
                {error !== false && error !== undefined ? (
                  <>
                    <Text mt="1.5em" color="red" fontWeight={'bold'} fontSize="sm" mb="1em">
                      {error}
                    </Text>
                  </>
                ) : position !== null ? (
                  position === false || position === undefined ? (
                    <></>
                  ) : (
                    <>
                      <Button position="absolute" bottom="10" ml="11em" isLoading colorScheme="whiteAlpha" variant="ghost"></Button>
                    </>
                  )
                ) : (
                  <></>
                )}
              </Box> */}
          </Box>
        </Box>
        <Box display={'flex'} flexDirection={'column'} alignItems={'center'} fontSize={md ? 'lg' : 'xs'} mt={4}>
          {reconnect === true ?? (
            <Text color="white" fontWeight="bold">
              Reconectando...
            </Text>
          )}
        </Box>
      </Center>

      <BottomNavBar />
    </>
  ) : (
    <>
      <ChildHeader />
      <VStack>
        <chakra.iframe
          width="95%"
          paddingTop="0.5em"
          height="600px"
          src={`https://atendimento.deovita.com.br:5000/atendimento?p=${paciente ? paciente : ''}&m=${medico ? medico : ''}&a=${
            agenda ? agenda : ''
          }&u=paciente`}
          allow="camera *;microphone *"
        ></chakra.iframe>
      </VStack>

      <BottomNavBar />
    </>
  );
}

export default AtendimentoTelmedicina;
